var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "table-heading mb-0 p-3 d-flex align-items-center justify-content-between",
      class: _vm.customClass,
    },
    [
      _c("h1", { staticClass: "title mb-0 fs-20 fw-500" }, [
        _vm._v(_vm._s(_vm.title)),
      ]),
      _vm._v(" "),
      _vm._t("actions"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }